import { cx } from './utils.js'

// Tabs (migrated off Tailwind in Wave 47q). Pill-style tab list with
// brand-orange active state. Styles live in .studio-tabs-* rules in
// studio.css.

export function Tabs({ tabs, value, onChange, ariaLabel = 'Tabs' }) {
  return (
    <div role="tablist" aria-label={ariaLabel} className="studio-tabs">
      {tabs.map((tab) => {
        const selected = tab.value === value
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={cx('studio-tabs-tab', selected ? 'selected' : '')}
            onClick={() => onChange(tab.value)}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
